import React from 'react';
import './index.less';

function ExamplePopup({ popup, click }) {
	return (
		<div className='example-custom-popup'>
			<button onClick={click}>
				example custom popup #{popup.id}
			</button>
		</div>
	);
}

export default ExamplePopup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/render-popup/render-custom-popup/custom-popups/example-popup/index.js